import { useState } from "react";
import Signup from "../../layouts/Signup";
import FormSign from "../../components/FormSign";
import "./style.css";

function Registration() {
    const [access, setAccess] = useState(false);
    const [form, setForm] = useState({
        email: '',
        password: '',
        confPassword: '',
        
        firstName: '',
        lastName: '',
        
        profession: '',
        otherProfession: '',
        
        mainLocation: '',
        secondaryLocations: '',
        
        proPhone: '',
        secretaryPhone: '',
        
        proEmail: '',
        secureProEmail: '',
        
        patientComTool: [],
        otherPatientComTool: '',
        
        adminComTool: [],
        otherAdminComTool: '',
        
        interproTool: [],
        otherInterproTool: '',
        
        meetingTool: [],
        otherMeetingTool: '',
        
        urgentContact: [],
        otherUrgentContact: '',
        
        dailyContact: [],
        otherDailyContact: '',
        
        weeklyContact: [],
        otherWeeklyContact: '',
        
        targetAudiences: [],
        otherTargetAudiences: '',
        
        importantInfo: '',
        code: ''
    });

    return (
        <div className="page_registration">
            {!access && <Signup form={form} setForm={setForm} setAccess={setAccess} />}
            {access && <FormSign form={form} setForm={setForm} />}
        </div>
    );
}

export default Registration;